import { captureException, withScope } from '@platform/observability';
import { enrichSentryScope } from './enrichSentryScope';
import { isDynamicImportLoadError } from './preloadErrorReload';

type ReactReportKind = 'react-caught' | 'react-uncaught' | 'react-recoverable';

export type BoundarySource = ReactReportKind | 'app' | 'router' | (string & {});

/** Empty event id when the error was suppressed. */
export function reportBoundaryError(error: unknown, source: BoundarySource, componentStack?: string): string {
  // Reload-once recovery already owns this (vite:preloadError, lazyRouteComponent); noise, not a crash.
  if (isDynamicImportLoadError(error)) {
    return '';
  }

  let eventId = '';
  withScope((scope) => {
    scope.setTag('error.boundary', true);
    scope.setTag('error.boundary.source', source);
    if (componentStack) {
      scope.setContext('componentStack', { stack: componentStack });
    }
    enrichSentryScope(error, scope);
    eventId = captureException(error);
  });
  return eventId;
}
